import { Form, Input, Modal, Select, notification } from "antd";
import { useMutation } from "urql";

import { graphql } from "@/__graphql__";

interface CreateContactPersonModalProps {
  relationId: string;
  locationId: string;
  open: boolean;
  onClose: () => void;
}

interface CreateContactPersonModalFormValues {
  name: string;
  emailAddresses?: string[];
  phoneNumbers?: string[];
}

const AddContactPersonMutation = graphql(`
  mutation Dashboard__ContactPersonsSection__AddContactPersonMutation($input: AddContactPersonInput!) {
    addContactPerson(input: $input) {
      location {
        id
      }
    }
  }
`);

export default function CreateContactPersonModal({ relationId, locationId, open, onClose }: CreateContactPersonModalProps) {
  const [form] = Form.useForm<CreateContactPersonModalFormValues>();

  const [{ fetching: loading }, addContactPerson] = useMutation(AddContactPersonMutation);

  const handleSubmit = async (values: CreateContactPersonModalFormValues) => {
    try {
      await addContactPerson({
        input: {
          relationId,
          locationId,
          name: values.name,
          emailAddresses: values.emailAddresses ?? [],
          phoneNumbers: values.phoneNumbers ?? [],
          notifications: [],
        },
      });

      onClose();
      form.resetFields();
    } catch {
      notification.error({ title: "Er ging iets mis bij het toevoegen van de contactpersoon." });
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      centered
      confirmLoading={loading}
      onCancel={handleCancel}
      onOk={() => form.submit()}
      open={open}
      title="Contactpersoon toevoegen"
    >
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item label="Naam" name="name" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item label="E-mail adressen" name="emailAddresses">
          <Select mode="tags" open={false} placeholder="Typ een e-mailadres en druk op enter" />
        </Form.Item>
        <Form.Item label="Telefoonnummers" name="phoneNumbers">
          <Select mode="tags" open={false} placeholder="Typ een telefoonnummer en druk op enter" />
        </Form.Item>
      </Form>
    </Modal>
  );
}
